import { IconOpenInNewSmall } from '@mzc-cloudplex/icons';
import { Box, Typography } from '@mzc-pdc/ui';
import React from 'react';
import { Link, LinkProps } from '../links/Link';

export const WithId = (
  props: { id: string; children: React.ReactNode; disabled?: boolean } & LinkProps
) => {
  // disabled면 링크/새창 아이콘을 제거해 이동 불가 상태로 표시 (권한없음·에러 항목)
  const to = props.disabled ? undefined : props.to;
  const target = props.disabled ? undefined : props.target;
  return (
    <Box display={'flex'} flexDirection={'column'} flexWrap={'nowrap'}>
      <Link to={to} target={target} >
        <Box display={'inline-flex'} alignItems={'center'} gap={0.75}>
          {props.children}
          {target === '_blank' && <IconOpenInNewSmall size={16} />}
        </Box>
      </Link>
      <Box display={'flex'} flexDirection={'row'}>
        <Link to={to} target={target}>
          <Typography variant={'body3'} color={'text.secondary'}>
            {props.id}
          </Typography>
        </Link>
      </Box>
    </Box>
  );
};
